import { render } from "./CompanyRegistration.vue?vue&type=template&id=ecaf086c&scoped=true"
import script from "./CompanyRegistration.vue?vue&type=script&lang=js"
export * from "./CompanyRegistration.vue?vue&type=script&lang=js"

import "./custom-company-registration.scss?vue&type=style&index=0&id=ecaf086c&lang=scss&scoped=true"
import "./CompanyRegistration.vue?vue&type=style&index=1&id=ecaf086c&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecaf086c"]])

export default __exports__